import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { APPCONFIG } from '../config';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LayoutService } from '../layout/layout.service';
import { SessionHandler } from '../shared/services/session-handler.service';

@Component({
    template: require('./dialog.component.html'),
})
export class dialogComponent implements OnInit {
    public msg:any;
    
    public isConfirm:boolean  = false;
    constructor(public dialog: MatDialog,public dialogRef: MatDialogRef<dialogComponent>)
    {}

    ngOnInit() {
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./termsDialogComponent.html')
})
export class termsDialogComponent implements OnInit {
    public msg:any;
    constructor(public dialog: MatDialog,public dialogRef: MatDialogRef<dialogComponent>)
    {}

    ngOnInit():void{
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./icbtermsDialogComponent.html'),
    providers:[SessionHandler]
})
export class icbtermsDialogComponent implements OnInit {
    public msg:any;
    public lan:any;
    constructor(private sessionHandler:SessionHandler,public dialog: MatDialog,public dialogRef: MatDialogRef<dialogComponent>)
    {}

    ngOnInit():void{
        this.lan = this.sessionHandler.getItem("defaultLanguage");
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./privacy.html'),
    providers:[SessionHandler]
})
export class privacyComponent implements OnInit {
    public msg:any;
    public lan:any;
    constructor(private sessionHandler:SessionHandler,public dialog: MatDialog,public dialogRef: MatDialogRef<dialogComponent>)
    {}

    ngOnInit():void{
        this.lan = this.sessionHandler.getItem("defaultLanguage");
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}